module.exports = __webpack_public_path__ + "img/40_00_078_202.543137d7.jpg";